// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card-description[data-v-e9331b9a] {\n\tcolor: #353535 !important;\n}\n.card-title[data-v-e9331b9a] {\n\tfont-weight: 500 !important;\n\tmargin-bottom: 0px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
